import type { RawGameConfig } from '../types/index';

export const GAME_CONFIG: RawGameConfig = {
  successRate: 0.4,
  nearMissRate: 0.2,
  clawSpeed: 1,
  dropSpeed: 1,
  baseRates: {
    A: 0.6,
    B: 0.4,
    C: 0.2,
  },
  experimentWeights: {
    A: 33,
    B: 34,
    C: 33,
  },
  defaultVersion: 'B',
  spawnRarity: {
    common: 0.6,
    rare: 0.3,
    legendary: 0.1,
  },
  softPity: {
    enabled: true,
    threshold10: 10,
    threshold20: 20,
    boost10: { rare: 0.4, legendary: 0.15 },
    boost20: { rare: 0.5, legendary: 0.35 },
  },
};
